<template>
  <div class="group-box">
    <!-- <div class="box-title">
      <div class="title f-16 f-c-999">基础设置</div>
    </div> -->
    <div class="box-list">
      <a-form :label-col="{ span: 2 }" :model="form" :wrapper-col="{ span: 8, offset: 1 }" autocomplete="off" name="basic">
        <a-form-item label="经营者类型" name="type">
          <a-radio-group v-model:value="form.type">
            <a-radio :value="1">企业</a-radio>
            <a-radio :value="2">个人</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="form.type == 1" label="企业名称" name="full_name">
          <a-input v-model:value="form.full_name" placeholder="请输入企业名称" />
        </a-form-item>
        <a-form-item v-if="form.type == 1" label="企业信用代码" name="credit_code">
          <a-input v-model:value="form.credit_code" placeholder="请输入企业信用代码" />
        </a-form-item>
        <a-form-item :label="form.type == 1 ? '企业法人姓名' : '经营者姓名'" name="user_name">
          <a-input v-model:value="form.user_name" placeholder="请输入姓名" />
        </a-form-item>
        <a-form-item :label="form.type == 1 ? '企业法人手机号' : '经营者手机号'" name="phone">
          <a-input v-model:value="form.phone" placeholder="请输入手机号" />
        </a-form-item>
        <a-form-item :label="form.type == 1 ? '企业法人身份证' : '经营者身份证'" name="card_num">
          <a-input v-model:value="form.card_num" placeholder="请输入身份证" />
        </a-form-item>
        <a-form-item label="经营状态" name="status">
          <a-radio-group v-model:value="form.status">
            <a-radio :value="1">开业</a-radio>
            <a-radio :value="2">停业</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="品牌名称" name="name">
          <a-input v-model:value="form.name" placeholder="请输入品牌名称" />
        </a-form-item>
        <a-form-item label="品牌LOGO" name="logo">
          <div class="image">
            <a-upload :action="action" :data="formData" :headers="header" :show-upload-list="false" class="avatar-uploader" name="image" @change="uploadLogo">
              <img :src="form.logo" alt="品牌LOGO" fit="fill" style="width: 80px; height: 80px; object-fit: cover; cursor: pointer" />
            </a-upload>
          </div>
        </a-form-item>
        <a-form-item label="所在区域：">
          <AreaSelect :placeholder="areaPlaceholder" class="areaSel" style="width: 100%" @changeArea="changeArea" />
        </a-form-item>
        <a-form-item label="导航定位：">
          <a-select v-model:value="location" :open="false" placeholder="请选择定位" style="width: 100%" @click="showMap = true"></a-select>
        </a-form-item>
        <a-form-item label="地址" name="address">
          <a-textarea v-model:value="form.address" placeholder="请输入地址" />
        </a-form-item>

        <a-form-item :wrapper-col="{ offset: 5, span: 16 }">
          <a-button html-type="submit" type="primary" @click="saveConfig">保存 </a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 地图定位 -->
    <map-select
      v-if="showMap"
      :latitude="form.latitude"
      :longitude="form.longitude"
      :showMap="showMap"
      @address="
        params => {
          form.address = params;
        }
      "
      @close="showMap = false"
      @selectValue="selectMap"
    />
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue';
import { companyBasics, companyEdit } from '@/api/api';
import AreaSelect from '@/components/pms/landlord/AreaSelect/AreaSelect.vue';
import MapSelect from '@/components/pms/landlord/MapSelect/MapSelect.vue';
import { message } from 'ant-design-vue';
import { baseRequestUrl } from '../../../../config.js';

export default {
  components: { AreaSelect, MapSelect },
  setup() {
    const config = reactive({
      location: '',
      showMap: false,
      areaPlaceholder: '所在区域',
      // 上传
      uploadLoading: false,
      action: baseRequestUrl + '/h5/upload/uploadImg' + '?info=' + JSON.parse(sessionStorage.getItem('landlordInfo')).info,
      header: {
        token: JSON.parse(sessionStorage.getItem('landlordInfo')).token,
        version: '1.0.0',
        source: '1',
      },
      formData: {
        module: 'pms',
        type: 'logo',
      },
      form: {},
      //   保存设置
      saveConfig() {
        let params = {
          type: config.form.type,
          full_name: config.form.full_name,
          credit_code: config.form.credit_code,
          user_name: config.form.user_name,
          phone: config.form.phone,
          card_num: config.form.card_num,
          status: config.form.status,
          name: config.form.name,
          logo: config.form.logo,
          longitude: config.form.longitude,
          latitude: config.form.latitude,
          province_name: config.form.province_name,
          city_name: config.form.city_name,
          area_name: config.form.area_name,
          province_id: config.form.province_id,
          city_id: config.form.city_id,
          area_id: config.form.area_id,
          address: config.form.address,
        };
        companyEdit(params).then(res => {
          message.success(res.msg);
          config.getConfig();
        });
      },
      //   定位回调
      selectMap(params) {
        config.form.longitude = params.longitude;
        config.form.latitude = params.latitude;
        config.location = '经度：' + `${params.latitude}` + '；纬度：' + `${params.longitude}`;
      },
      // 选择区域回调
      changeArea(params) {
        if (params) {
          Object.assign(config.form, params);
        }
      },
      // 获取设置
      getConfig() {
        companyBasics().then(res => {
          config.form = res.data;
          if (res.data.province_name) {
            config.areaPlaceholder = res.data.province_name + ' / ' + res.data.city_name + ' / ' + res.data.area_name;
            config.location = '经度：' + `${res.data.latitude}` + '；纬度：' + `${res.data.longitude}`;
          }
        });
      },
      //  上传图片
      uploadLogo(info) {
        if (info.file.status === 'done') {
          config.form.logo = info.file.response.data.url;
        }
      },
    });

    onMounted(() => {
      config.getConfig();
    });

    return {
      ...toRefs(config),
    };
  },
};
</script>

<style lang="scss" scoped>
:deep(.areaSel) {
  input::-webkit-input-placeholder {
    color: #262626;
  }

  input:-ms-input-placeholder {
    // IE 10 +
    color: #262626;
  }

  input:-moz-placeholder {
    // Firefox 4 -18
    color: #262626;
  }

  input::-moz-placeholder {
    // Firefox 19 +
    color: #262626;
  }
}

.group-box {
  background-color: #fff;
  width: 100%;
  //   box-shadow: 0 0 5px #99999933;
  .box-title {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #f2f2f2;

    .title {
    }

    .btn {
    }
  }

  .box-list {
    padding: 20px;

    .list-lef {
      .lef-name {
        margin-bottom: 5px;
      }

      .lef-num {
      }
    }

    .list-rig {
      display: flex;
    }
  }
}
</style>
